import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Suspense as _Suspense, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e18f8ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = { class: "breadcrumb-item active" }
const _hoisted_5 = { "aria-current": "location" }
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "col-md-9" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = {
  key: 0,
  class: "card-img-top"
}
const _hoisted_10 = { class: "ratio ratio-16x9" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "text-muted" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_16 = { class: "col-md" }
const _hoisted_17 = { class: "card mt-3 mt-md-0" }
const _hoisted_18 = { class: "card-body d-flex flex-column" }
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_21 = { class: "row" }
const _hoisted_22 = {
  key: 0,
  class: "col"
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 1,
  class: "col"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_26 = {
  key: 0,
  class: "mb-0 mt-2"
}
const _hoisted_27 = {
  key: 1,
  class: "row"
}
const _hoisted_28 = { class: "card mt-5" }
const _hoisted_29 = {
  class: "card-body",
  style: {"min-height":"150px"}
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_user_link = _resolveComponent("user-link")
  const _component_time_ago = _resolveComponent("time-ago")
  const _component_icon = _resolveComponent("icon")
  const _component_spinner = _resolveComponent("spinner")

  return ($setup.creation)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode($setup["MetaTag"], {
          name: "og:title",
          content: $setup.creation.title
        }, null, 8, ["content"]),
        _createVNode($setup["MetaTag"], {
          name: "og:url",
          content: $setup.endpoints.main(`/view/${$setup.creation.id}`)
        }, null, 8, ["content"]),
        _createVNode($setup["MetaTag"], {
          names: ['og:description', 'description'],
          content: $setup.stub($setup.creation.renderedBody)
        }, null, 8, ["content"]),
        _createVNode($setup["FeedTag"], {
          "object-id": $setup.creation.id
        }, null, 8, ["object-id"]),
        _createVNode($setup["TitleTag"], {
          title: $setup.creation.title
        }, null, 8, ["title"]),
        _createElementVNode("ol", _hoisted_2, [
          _createElementVNode("li", _hoisted_3, [
            _createVNode(_component_router_link, { to: "/hub" }, {
              default: _withCtx(() => [
                _createTextVNode("Creation hub")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString($setup.creation.title), 1)
          ])
        ]),
        (!$setup.isEditing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (!$setup.isEditing)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        ($setup.creation.images.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createVNode($setup["Carousel"], {
                                  class: "carousel",
                                  count: $setup.creation.images.length
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.creation.images, (img, i) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: _normalizeClass(["carousel-item h-100", {active: i == 0}])
                                      }, [
                                        _createElementVNode("img", {
                                          class: "carousel-image",
                                          src: 'https://assets.logicworld.net/upload/' + img
                                        }, null, 8, _hoisted_11)
                                      ], 2))
                                    }), 256))
                                  ]),
                                  _: 1
                                }, 8, ["count"])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("h1", null, _toDisplayString($setup.creation.title), 1),
                          _createElementVNode("span", _hoisted_13, [
                            _createTextVNode("by "),
                            _createVNode(_component_user_link, {
                              user: $setup.creation.author
                            }, null, 8, ["user"]),
                            _createVNode(_component_time_ago, {
                              time: $setup.creation.createdAt
                            }, null, 8, ["time"]),
                            ($setup.creation.editedAt)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" (edited"),
                                  _createVNode(_component_time_ago, {
                                    time: $setup.creation.editedAt
                                  }, null, 8, ["time"]),
                                  _createTextVNode(")")
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _hoisted_14,
                          _createVNode($setup["Markdown"], {
                            html: $setup.creation.renderedBody
                          }, null, 8, ["html"]),
                          _hoisted_15,
                          _createVNode($setup["BottomSocials"], {
                            "object-id": $props.id,
                            rating: $setup.creation.rating
                          }, null, 8, ["object-id", "rating"])
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode($setup["OpenInGameButton"], {
                      class: "w-100",
                      creationId: $setup.creation.id
                    }, null, 8, ["creationId"]),
                    _createVNode(_component_router_link, {
                      class: "text-center",
                      to: "/view/pst-56609d78"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Help with this feature")
                      ]),
                      _: 1
                    }),
                    _createElementVNode("a", {
                      class: "btn btn-success w-100 mt-4",
                      href: $setup.creation.fileUrl,
                      download: "download"
                    }, [
                      _createVNode(_component_icon, {
                        class: "me-2",
                        icon: "download"
                      }),
                      _createTextVNode("Download")
                    ], 8, _hoisted_19),
                    ($setup.canEdit || $setup.canDelete)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_20,
                          _createElementVNode("div", _hoisted_21, [
                            ($setup.canEdit)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  _createElementVNode("button", {
                                    class: "btn btn-warning w-100",
                                    onClick: _cache[0] || (_cache[0] = $event => ($setup.isEditing = true)),
                                    disabled: $setup.isEditing
                                  }, [
                                    _createVNode(_component_icon, {
                                      class: "me-2",
                                      icon: "edit",
                                      "fixed-width": "fixed-width"
                                    }),
                                    _createTextVNode("Edit")
                                  ], 8, _hoisted_23)
                                ]))
                              : _createCommentVNode("", true),
                            ($setup.canDelete)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  _createElementVNode("button", {
                                    class: "btn btn-danger w-100",
                                    onClick: $setup.deleteCreation
                                  }, [
                                    _createVNode(_component_icon, {
                                      class: "me-2",
                                      icon: "trash",
                                      "fixed-width": "fixed-width"
                                    }),
                                    _createTextVNode("Delete")
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    _hoisted_25,
                    _createElementVNode("div", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge fs-6", ['bg-' + $setup.kindName[$setup.creation.kind].color]])
                      }, _toDisplayString($setup.kindName[$setup.creation.kind].name), 3),
                      ($setup.creation.metadata.length > 0)
                        ? (_openBlock(), _createElementBlock("dl", _hoisted_26, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.metadata, (md) => {
                              return (_openBlock(), _createElementBlock(_Fragment, null, [
                                _createElementVNode("dt", null, _toDisplayString($setup.metadataName[md.key]), 1),
                                _createElementVNode("dd", null, _toDisplayString(md.value), 1)
                              ], 64))
                            }), 256))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createVNode($setup["EditCreation"], {
                creation: $setup.creation,
                onCancel: _cache[1] || (_cache[1] = $event => ($setup.isEditing = false)),
                onDone: $setup.doneEditing
              }, null, 8, ["creation"])
            ])),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            (_openBlock(), _createBlock(_Suspense, { timeout: "0" }, {
              fallback: _withCtx(() => [
                _createVNode(_component_spinner)
              ]),
              default: _withCtx(() => [
                _createVNode($setup["CommentList"], { objectid: $props.id }, null, 8, ["objectid"])
              ]),
              _: 1
            }))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}